import { LEVEL_NAMES } from './ConnectionLevelModal';

export const ConnectionLevelCircle = ({
  level,
  driftInfo,
  onClick,
}) => {
  const driftBonus = driftInfo?.drift_bonus || 0;
  
  return (
    <div 
      className="fixed top-[70px] left-4 sm:left-4 right-auto sm:right-auto z-50 flex flex-col items-center cursor-pointer group max-sm:left-auto max-sm:right-4"
      onClick={onClick}
      title="Click to view connection levels"
    >
      {/* SVG Circular Display with Drift Animation */}
      <svg 
        className={`w-14 h-14 drop-shadow-lg group-hover:scale-105 transition-transform ${
          driftBonus === 1 ? "animate-pulse" : 
          driftBonus >= 2 ? "animate-[pulse_0.5s_ease-in-out_infinite]" : ""
        }`} 
        viewBox="0 0 48 48"
      >
        {/* Background circle - color changes with drift */}
        <circle
          cx="24"
          cy="24"
          r="22"
          fill="rgba(15,15,20,0.9)"
          stroke={
            driftBonus >= 2 ? "rgba(147,51,234,0.6)" :  // Purple for +2
            driftBonus === 1 ? "rgba(34,197,94,0.5)" :  // Green for +1
            "rgba(212,175,55,0.3)"  // Gold for no drift
          }
          strokeWidth="3"
          className="transition-colors duration-500"
        />
        {/* Decorative ring */}
        <circle
          cx="24"
          cy="24"
          r="19"
          fill="none"
          stroke={
            driftBonus >= 2 ? "rgba(147,51,234,0.8)" :
            driftBonus === 1 ? "rgba(34,197,94,0.7)" :
            "rgba(212,175,55,0.5)"
          }
          strokeWidth="2"
          className="transition-colors duration-500"
        />
      </svg>
      {/* Level number in center */}
      <div className="absolute top-0 w-14 h-14 flex items-center justify-center">
        <span className={`font-bold text-xl transition-colors duration-500 ${
          driftBonus >= 2 ? "text-purple-400" :
          driftBonus === 1 ? "text-green-400" :
          "text-divine-gold"
        }`}>
          {level}
        </span>
      </div>
      {/* Level name with drift indicator */}
      <span className={`text-[10px] font-medium mt-1 transition-colors duration-500 ${
        driftBonus >= 2 ? "text-purple-400" :
        driftBonus === 1 ? "text-green-400" :
        "text-divine-gold/70 group-hover:text-divine-gold"
      }`}>
        {LEVEL_NAMES[level] || "Unknown"}
        {driftBonus > 0 && (
          <span className="ml-1 font-bold">+{driftBonus}</span>
        )}
      </span>
    </div>
  );
};

export default ConnectionLevelCircle;
